import React from 'react';
import { Col } from 'react-bootstrap';
import './Hotel.css';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Hotel = ({ hotel: { img, title, guests, bedrooms, beds, baths, facility, others, rating, totalRating, cost, totalCost } }) => {
    return (
        <div className="d-flex p-2 m-2">
            <Col xs={5}>
                <img src={img} alt="" className="thumbnail" />
            </Col>
            <Col xs={10}>
                <h6>{title}</h6>
                <p className="text-secondary">{guests} guests, {bedrooms} bedrooms, {beds} beds, {baths} baths</p>
                <p className="text-secondary">{facility}</p>
                <p className="text-secondary">{others}</p>
                <p><FontAwesomeIcon style={{ color: '#FFAF38' }} icon={faStar} /><strong> {rating}({totalRating}) ${cost}/</strong>night <span className="text-secondary"><strong>{totalCost}</strong> total</span></p>
            </Col>
        </div>
    );
};

export default Hotel;